var React = require('react');

function XThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.75 5.25L5.25 12.75M5.25 5.25L12.75 12.75","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

XThin.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = XThin;

XThin.default = XThin;
